import type { TFacebookCampaign } from './facebook';
import { FacebookCampaign } from './facebook';
import type { CampaignClass } from './types';

export type TEmailListFacebookCampaign = TFacebookCampaign & {
  readonly _cls: CampaignClass.EmailListFacebook;
};

export class EmailListFacebookCampaign extends FacebookCampaign<TEmailListFacebookCampaign> {}
